import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const bbqApi = {
  getUnansweredMessage: (request) => {
    const { config } = request
    return instance().get('/bbq/unanswer-message', config)
  },
  getAudienceList: (request) => {
    const { config } = request
    const url = `/api/bbq-connectx/audiences`
    return instance().get(url, { params: config })
  },
  deleteAudience: (request) => {
    const { config } = request
    const url = `/api/bbq-connectx/audience/delete-group`
    return instance().delete(url, { params: config })
  }
}
export default bbqApi



// WEBPACK FOOTER //
// ./src/api/bbq.js